/**
 * Admin > BRO Insights & News. create/edit: Quill 본문, 제출 시 textarea 동기화.
 */
import { Logger } from "../../utils/Logger";
import { QuillEditor, stripBase64Images } from "../../components/QuillEditor";

const CTRL_TAG = "AdminInsightNewsController";

function noop(action: string): void {
    Logger.debug(`${CTRL_TAG}.${action} (no-op)`);
}

function initBodyEditor(): void {
    const form = document.querySelector<HTMLFormElement>("form#insights-news-form");
    const editorEl = document.getElementById("in-body-editor");
    const bodyInput = document.getElementById("in-body") as HTMLTextAreaElement | null;
    if (!form || !editorEl || !bodyInput) return;

    const uploadImageUrl = form.dataset.uploadImageUrl ?? "";
    const csrf = (form.querySelector('input[name="_token"]') as HTMLInputElement | null)?.value ?? "";

    let initialHtml = "";
    const initEl = document.getElementById("insight-body-initial");
    if (initEl?.textContent) {
        try {
            initialHtml = JSON.parse(initEl.textContent) as string;
        } catch {
            initialHtml = "";
        }
    }

    const uploadConfig =
        uploadImageUrl && csrf
            ? {
                  uploadUrl: uploadImageUrl,
                  csrf,
                  fileKey: "image" as const,
                  getUrl: (json: Record<string, unknown>) =>
                      (json?.data as Record<string, unknown>)?.url as string | undefined,
              }
            : undefined;

    const quill = new QuillEditor(editorEl, {
        placeholder: "본문을 입력하세요. 이미지는 툴바에서 삽입할 수 있습니다.",
        initialHtml,
        upload: uploadConfig,
    });
    quill.init();

    form.addEventListener(
        "submit",
        () => {
            bodyInput.value = stripBase64Images(quill.getHtml());
        },
        true
    );
}

export const AdminInsightNewsController = {
    index(): void {
        noop("index");
    },
    create(): void {
        initBodyEditor();
    },
    store(): void {
        noop("store");
    },
    edit(): void {
        initBodyEditor();
    },
    update(): void {
        noop("update");
    },
    destroy(): void {
        noop("destroy");
    },
};
